var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delivery-collection-kpi-drill-through-main"},[_c('div',{staticClass:"drill-through-body"},[_c('TableBox',{attrs:{"title":_vm.tableTitle,"tableData":_vm.drillThroughDetails,"dataType":_vm.tableDataType}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }